var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"favorite-grid-root mb-3"},_vm._l((_vm.data),function(fav){return _c('FavoriteCard',{key:fav.id,attrs:{"data":fav}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }